import { createBrowserRouter } from 'react-router-dom';
import { App } from './App';
import NewOverviewPage from '../features/overview/NewOverviewPage';
import PimRouter from '../features/pim/PimRouter';
import ApiManagerPage from '../features/apis/ApiManagerPage';
import EnhancedSystemHealthPage from "../pages/EnhancedSystemHealthPage";
import { RequireOps } from "@/components/RequireOps";
import AppInstancesPage from '../features/apps/AppInstancesPage';
import ContextualizerRouter from '../features/contextualizer/ContextualizerRouter';
import IoTRouter from '../features/iot/IoTRouter';
import AgentManagerRouter from '../features/agents/AgentManagerRouter';
import DAMRouter from '../features/dam/DAMRouter';
import RelationshipManager from '../features/relationships/RelationshipManager';
import SettingsPage from '../features/settings/SettingsPage';
import AgentChat from '../pages/AgentChat';
import ApiManagerDashboard from '../features/api-manager/ApiManagerDashboard';
import ApiIngestDashboard from '../features/api-manager/ApiIngestDashboard';
import ApiExposeDashboard from '../features/api-manager/ApiExposeDashboard';
import DataFlowManager from '../features/dataflow/DataFlowManager';
import SecretsManagerPage from '../pages/SecretsManagerPage';
import UsersAndAccessPage from '../features/iam/UsersAndAccessPage';
import AssetRouter from '../features/asset/AssetRouter';
import EntityRouter from '../features/entity/EntityRouter';
import InterpreterRouter from '../features/interpreter/InterpreterRouter';
import MapperStandalonePage from '../features/mapper/MapperStandalonePage';
import MapperEmbedPage from '../features/mapper/MapperEmbedPage';
import MapperEmbedHost from '../features/mapper/MapperEmbedHost';
import PulsarPage from '../pages/PulsarPage';
import McpEventsSearchPage from '../pages/McpEventsSearchPage';
import ApiObservePage from '../pages/ApiObserve/ApiObservePage';
import DeltaChangelogPage from '../pages/DeltaChangelogPage';
import OpsHandoffPage from '../pages/OpsHandoffPage';
import LearningPage from '../pages/LearningPage';
import AgentActionsPage from '../features/agent-actions/components/AgentActionsPage';
import { Navigate } from 'react-router-dom';
import McpCardStatePreview from '../pages/McpCardStatePreview';
import DataFlowBoardPreview from '../pages/DataFlowBoardPreview';

export const router = createBrowserRouter([
  { path: '/__preview/mcp-card-states', element: <McpCardStatePreview /> },
  { path: '/__preview/dataflow-board', element: <DataFlowBoardPreview /> },
  { path: '/mapper/embed', element: <MapperEmbedPage /> },
  { path: '/mapper/embed-host', element: <MapperEmbedHost /> },
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <NewOverviewPage /> },
      { path: 'overview', element: <NewOverviewPage /> },
      { path: 'system', element: <EnhancedSystemHealthPage /> },
      { path: 'system-health', element: <EnhancedSystemHealthPage /> },
      { path: 'apps/*', element: <AppInstancesPage /> },
      { path: 'apis/*', element: <RequireOps><ApiManagerPage /></RequireOps> },
      // API Manager UI split (preferred)
      { path: 'api-ingest', element: <ApiIngestDashboard /> },
      { path: 'api-expose', element: <ApiExposeDashboard /> },
      { path: 'api-observe', element: <RequireOps><ApiObservePage /></RequireOps> },
      // Back-compat: old route redirects to ingest
      { path: 'api-manager', element: <Navigate to="/api-ingest" replace /> },
      { path: 'iotshack/*', element: <IoTRouter /> },
      { path: 'agents/*', element: <AgentManagerRouter /> },
      { path: 'learning', element: <RequireOps><LearningPage /></RequireOps> },
      // Legacy agent-creator removed - using Volcano workflow designer at /agents/volcano/:id/edit
      { path: 'dataflow', element: <DataFlowManager /> },
      { path: 'dataflow/:flowId', element: <DataFlowManager /> },
      { path: 'pim/*', element: <PimRouter /> },
      { path: 'dam/*', element: <DAMRouter /> },
      { path: 'asset/*', element: <AssetRouter /> },
      { path: 'entity/*', element: <EntityRouter /> },
      { path: 'interpreter/*', element: <RequireOps><InterpreterRouter /></RequireOps> },
      { path: 'mapper', element: <MapperStandalonePage /> },
      { path: 'contextualizer/*', element: <ContextualizerRouter /> },
      { path: 'iam', element: <RequireOps><UsersAndAccessPage /></RequireOps> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'secrets', element: <RequireOps><SecretsManagerPage /></RequireOps> },
      { path: 'pulsar', element: <Navigate to="/ops/pulsar" replace /> },
      { path: 'ops/pulsar', element: <RequireOps><PulsarPage /></RequireOps> },
      { path: 'ops/mcp-events', element: <RequireOps><McpEventsSearchPage /></RequireOps> },
      { path: 'ops/delta-changelog', element: <RequireOps><DeltaChangelogPage /></RequireOps> },
      { path: 'ops/handoff', element: <RequireOps><OpsHandoffPage /></RequireOps> },
      { path: 'agent-actions', element: <AgentActionsPage /> },
      { path: 'relationships', element: <RelationshipManager /> },
      { path: 'agent-chat', element: <AgentChat /> },
    ],
  },
]);
